import { Role } from "./models/Role";
import { User } from "./models/User";

const userHasPermission = (user: User, permissionKey: string, clientRoles: Role[], permitRegisterId: string, permitTypeId: string): boolean => {
    const rolesThatHavePermission = clientRoles.filter((r) => r.permissionKeys.includes(permissionKey));
    return !!user.assignments.find(
        (a) =>
            a.permitRegister?.id === permitRegisterId &&
            a.permitType?.id === permitTypeId &&
            rolesThatHavePermission.find((r) => r.id === a.roleId)
    );
};

const service = { userHasPermission };
export default service;
